import gql from 'graphql-tag';

export default gql(`
	query app_messages {
		app_messages {
			guid
			date_start
			date_end
			active
			
			translations {
				field
				title
				description
				
				language {
					code
				}
			}
		}
	}
`);

